import LogoLoader from 'components/_common/LogoLoader';
import AdminMainDarkLayout from 'layouts/admin/AdminMainDarkLayout';
import AdminMainLayout from 'layouts/admin/AdminMainLayout';
import AdminProfileLayout from 'layouts/admin/AdminProfileLayout';
// import AuthLayout from 'layouts/AuthLayout';
import AdminTabLayout from 'layouts/admin/AdminTabLayout';
import CustomerProfileLayout from 'layouts/admin/CustomerProfileLayout';
import CustomerMainLayout from 'layouts/customer/CustomerMainLayout';
import ForgotPaswordLayout from 'layouts/ForgotPaswordLayout';
import LoginLayout from 'layouts/LoginLayout';
import PlainPageLayout from 'layouts/PlainPageLayout';
import Error404 from 'modules/admin/components/Error/Error404';
import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { PreloaderComponent } from '../modules/admin/components/_common/Preloader';

import {
  loginRoutes,
  adminMainRoutes,
  adminProfileMain,
  adminProfileRoutes,
  plainPageRoutes,
  uiAdminPageRoutes,
  adminEmployeeRoutes,
  adminCustomerRoutes,
  adminGunsForSaleRoutes,
  adminAffiliateRoutes,
  forgotPasswordRoutes,
  adminBlogRoutes,
  adminBlogChildRoutes,
  adminProductRoutes,
  adminAdvertisementRoutes,
  adminSettingRoutes,
  adminReviewRoutes,
  adminSMSRoutes,
  adminSupportRequestRoutes,
} from './admin/AdminRoutes';
import {
  customerAuthRoutes,
  customerMainRoutes,
  customerProfileMain,
  customerProfileRoutes,
} from './customer/CustomerRoutes';

export default function RouteWrapper() {
  const uiAdminPageRoutesKeys = Object.keys(uiAdminPageRoutes);
  const plainPageRoutesKeys = Object.keys(plainPageRoutes);
  const loginRouteKeys = Object.keys(loginRoutes);
  const forgotPasswordRouteKeys = Object.keys(forgotPasswordRoutes);
  // customer related routes...start..
  const customerAuthRouteKeys = Object.keys(customerAuthRoutes);
  const customerMainRouteKeys = Object.keys(customerMainRoutes);
  const customerProfileRouteKeys = Object.keys(customerProfileRoutes);
  // customer related routes..end...
  // admin related routes...start..
  const adminMainRouteKeys = Object.keys(adminMainRoutes);
  const adminProfileRouteKeys = Object.keys(adminProfileRoutes);
  const adminSMSRoutesKeys = Object.keys(adminSMSRoutes);
  const adminBlogRouteKeys = Object.keys(adminBlogRoutes);
  const adminBlogChildRouteKeys = Object.keys(adminBlogChildRoutes);
  const adminEmployeeRouteKeys = Object.keys(adminEmployeeRoutes);
  const adminCustomerRouteKeys = Object.keys(adminCustomerRoutes);
  const adminAffiliateRouteKeys = Object.keys(adminAffiliateRoutes);
  const adminProductRouteKeys = Object.keys(adminProductRoutes);
  const adminReviewRouteKeys = Object.keys(adminReviewRoutes);
  const adminGunsForSaleRoutesKeys = Object.keys(adminGunsForSaleRoutes);
  const adminAdvertisementRoutesKeys = Object.keys(adminAdvertisementRoutes);
  const adminSettingRouteKeys = Object.keys(adminSettingRoutes);
  const adminSupportRequestRouteKeys = Object.keys(adminSupportRequestRoutes);
  return (
    <Suspense fallback={<PreloaderComponent />}>
      <Routes>
        {/* UI Page Routes */}
        <Route element={<AdminMainDarkLayout />}>
          {uiAdminPageRoutesKeys.map((routeKey, i) => {
            const uiAdminPageRoute = uiAdminPageRoutes[routeKey];

            if (!uiAdminPageRoute) {
              return null;
            }

            return (
              <Route key={i} path={uiAdminPageRoute.path} element={uiAdminPageRoute.element} />
            );
          })}
        </Route>
        {/* Customer Auth Routes */}
        <Route element={<LoginLayout />}>
          {customerAuthRouteKeys.map((key, i) => {
            const route = customerAuthRoutes[key];
            return <Route key={i} path={route.path} element={route.element} />;
          })}
        </Route>
        {/* Customer Main Routes */}
        <Route element={<CustomerMainLayout />}>
          {customerMainRouteKeys.map((key, i) => {
            const route = customerMainRoutes[key];
            //  return <Route key={i} path={route.path} element={route.element} />;
            return (
              <Route
                key={i}
                path={route.path}
                element={<Suspense fallback={<LogoLoader />}>{route.element}</Suspense>}
              />
            );
          })}
          {/* Customer Profile routes */}
          <Route path={customerProfileMain.path} element={<CustomerProfileLayout />}>
            {customerProfileRouteKeys.map((routeKey, i) => {
              const profileRoute = customerProfileRoutes[routeKey];

              if (!profileRoute) {
                return null;
              }

              return <Route key={i} path={profileRoute.path} element={profileRoute.element} />;
            })}
          </Route>
        </Route>
        {/* Login Layout Routes */}
        <Route element={<LoginLayout />}>
          {loginRouteKeys
            .filter((key) => loginRoutes[key].layout === 'login')
            .map((key, i) => {
              const route = loginRoutes[key];
              return <Route key={i} path={route.path} element={route.element} />;
            })}
        </Route>
        <Route element={<ForgotPaswordLayout />}>
          {loginRouteKeys
            .filter((key) => loginRoutes[key].layout === 'forgotPassword')
            .map((key, i) => {
              const route = loginRoutes[key];
              return <Route key={i} path={route.path} element={route.element} />;
            })}
        </Route>
        {/* forgotPassword Layout Routes */}
        <Route element={<ForgotPaswordLayout />}>
          {forgotPasswordRouteKeys
            // .filter((key) => loginRoutes[key].layout === 'login')
            .map((key, i) => {
              const route = forgotPasswordRoutes[key];
              return <Route key={i} path={route.path} element={route.element} />;
            })}
        </Route>

        {/* Auth Layout Routes */}
        {/* <Route element={<AuthLayout />}>
          {loginRouteKeys
            .filter((key) => loginRoutes[key].layout === 'auth')
            .map((key, i) => {
              const route = loginRoutes[key];
              return <Route key={i} path={route.path} element={route.element} />;
            })}
        </Route> */}

        {/* Plain Page Layout Routes */}
        <Route element={<PlainPageLayout />}>
          {plainPageRoutesKeys.map((routeKey, i) => {
            const plainPageRoute = plainPageRoutes[routeKey];

            if (!plainPageRoute) {
              return null;
            }

            return <Route key={i} path={plainPageRoute.path} element={plainPageRoute.element} />;
          })}
        </Route>
        {/* Admin Panel Layout Routes */}
        <Route element={<AdminMainLayout />}>
          {adminMainRouteKeys.map((routeKey, i) => {
            const adminMainRoute = adminMainRoutes[routeKey];

            if (!adminMainRoute) {
              return null;
            }

            return <Route key={i} path={adminMainRoute.path} element={adminMainRoute.element} />;
          })}

          {/* admin Profile routes */}
          <Route path={adminProfileMain.path} element={<AdminProfileLayout />}>
            {adminProfileRouteKeys.map((routeKey, i) => {
              const profileRoute = adminProfileRoutes[routeKey];

              if (!profileRoute) {
                return null;
              }

              return <Route key={i} path={profileRoute.path} element={profileRoute.element} />;
            })}
          </Route>
          {/* admin SMS routes */}
          <Route element={<AdminTabLayout tabs={Object.values(adminSMSRoutes) as any} />}>
            {adminSMSRoutesKeys.map((routeKey, i) => {
              const adminSMSRoute = adminSMSRoutes[routeKey];
              if (!adminSMSRoute) return null;
              return <Route key={i} path={adminSMSRoute.path} element={adminSMSRoute.element} />;
            })}
          </Route>
          {/* admin Blog routes */}
          {/* <Route element={<AdminTabLayout tabs={Object.values(adminBlogRoutes) as any} />}>
            {adminBlogRouteKeys.map((routeKey, i) => {
              const adminBlogRoute = adminBlogRoutes[routeKey];

              if (!adminBlogRoute) {
                return null;
              }

              return <Route key={i} path={adminBlogRoute.path} element={adminBlogRoute.element} />;
            })}
          </Route> */}
          <Route
            element={
              <AdminTabLayout
                tabs={Object.values(adminBlogRoutes) as any}
                childPaths={Object.values(adminBlogChildRoutes).map((r) => r.path)}
              />
            }
          >
            {adminBlogRouteKeys.map((routeKey, i) => {
              const adminBlogRoute = adminBlogRoutes[routeKey];
              if (!adminBlogRoute) return null;
              return <Route key={i} path={adminBlogRoute.path} element={adminBlogRoute.element} />;
            })}
            {adminBlogChildRouteKeys.map((routeKey, i) => {
              const route = adminBlogChildRoutes[routeKey];
              if (!route) return null;
              return <Route key={`child-${i}`} path={route.path} element={route.element} />;
            })}
          </Route>
          {/* admin Customer routes */}
          <Route element={<AdminTabLayout tabs={Object.values(adminCustomerRoutes) as any} />}>
            {adminCustomerRouteKeys.map((routeKey, i) => {
              const adminCustomerRoute = adminCustomerRoutes[routeKey];

              if (!adminCustomerRoute) {
                return null;
              }

              return (
                <Route
                  key={i}
                  path={adminCustomerRoute.path}
                  element={adminCustomerRoute.element}
                />
              );
            })}
          </Route>
          {/* admin Employee routes */}
          <Route element={<AdminTabLayout tabs={Object.values(adminEmployeeRoutes) as any} />}>
            {adminEmployeeRouteKeys.map((routeKey, i) => {
              const adminEmployeeRoute = adminEmployeeRoutes[routeKey];

              if (!adminEmployeeRoute) {
                return null;
              }

              return (
                <Route
                  key={i}
                  path={adminEmployeeRoute.path}
                  element={adminEmployeeRoute.element}
                />
              );
            })}
          </Route>
          {/* admin Support Request routes */}
          <Route
            element={<AdminTabLayout tabs={Object.values(adminSupportRequestRoutes) as any} />}
          >
            {adminSupportRequestRouteKeys.map((routeKey, i) => {
              const adminSupportRequestRoute = adminSupportRequestRoutes[routeKey];

              if (!adminSupportRequestRoute) {
                return null;
              }

              return (
                <Route
                  key={i}
                  path={adminSupportRequestRoute.path}
                  element={adminSupportRequestRoute.element}
                />
              );
            })}
          </Route>
          <Route element={<AdminTabLayout tabs={Object.values(adminAffiliateRoutes) as any} />}>
            {adminAffiliateRouteKeys.map((routeKey, i) => {
              const adminAffiliateRoute = adminAffiliateRoutes[routeKey];

              if (!adminAffiliateRoute) {
                return null;
              }

              return (
                <Route
                  key={i}
                  path={adminAffiliateRoute.path}
                  element={adminAffiliateRoute.element}
                />
              );
            })}
          </Route>
          <Route
            element={
              <AdminTabLayout
                tabs={Object.values(adminProductRoutes) as any}
                className="admin-product-layout"
              />
            }
          >
            {adminProductRouteKeys.map((routeKey, i) => {
              const adminProductRoute = adminProductRoutes[routeKey];

              if (!adminProductRoute) {
                return null;
              }

              return (
                <Route key={i} path={adminProductRoute.path} element={adminProductRoute.element} />
              );
            })}
          </Route>
          <Route
            element={
              <AdminTabLayout
                tabs={Object.values(adminReviewRoutes) as any}
                className="admin-review-layout"
              />
            }
          >
            {adminReviewRouteKeys.map((routeKey, i) => {
              const adminReviewRoute = adminReviewRoutes[routeKey];

              if (!adminReviewRoute) {
                return null;
              }

              return (
                <Route key={i} path={adminReviewRoute.path} element={adminReviewRoute.element} />
              );
            })}
          </Route>
          {/* admin Guns for sale routes */}
          <Route
            element={
              <AdminTabLayout
                tabs={Object.values(adminGunsForSaleRoutes) as any}
                className="admin-gun-layout"
              />
            }
          >
            {adminGunsForSaleRoutesKeys.map((routeKey, i) => {
              const adminGunsForSaleRoute = adminGunsForSaleRoutes[routeKey];

              if (!adminGunsForSaleRoute) {
                return null;
              }

              return (
                <Route
                  key={i}
                  path={adminGunsForSaleRoute.path}
                  element={adminGunsForSaleRoute.element}
                />
              );
            })}
          </Route>
          {/* admin setting routes */}
          <Route element={<AdminTabLayout tabs={Object.values(adminSettingRoutes) as any} />}>
            {adminSettingRouteKeys.map((routeKey, i) => {
              const adminSettingRoute = adminSettingRoutes[routeKey];

              if (!adminSettingRoute) {
                return null;
              }

              return (
                <Route key={i} path={adminSettingRoute.path} element={adminSettingRoute.element} />
              );
            })}
          </Route>
          {/* admin advertisement routes */}
          <Route element={<AdminTabLayout tabs={Object.values(adminAdvertisementRoutes) as any} />}>
            {adminAdvertisementRoutesKeys.map((routeKey, i) => {
              const adminAdvertisementRoute = adminAdvertisementRoutes[routeKey];

              if (!adminAdvertisementRoute) {
                return null;
              }

              return (
                <Route
                  key={i}
                  path={adminAdvertisementRoute.path}
                  element={adminAdvertisementRoute.element}
                />
              );
            })}
          </Route>
        </Route>
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Suspense>
  );
}
